import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastData {
    message: string;
    type: 'success' | 'error';
    duration?: number;
}

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private toastSubject = new Subject<ToastData>();
    toastState$ = this.toastSubject.asObservable();

    show(message: string, type: 'success' | 'error' = 'success', duration: number = 3000): void {
        this.toastSubject.next({ message, type, duration });
    }
}
